
















import Vue from "vue";
import { Component } from "vue-property-decorator";
import WsResponseModel from "../../../api/dataSource/api/SchemaBuilderServer/Models/WsResponseModel";
import NewsDetail from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/NewsModels/NewsDetail";

@Component
export default class PageNewsDetailsComponent extends Vue {
  detail: WsResponseModel<NewsDetail> = null;
  constructor() {
    super();
  }
  created() {
  }
  mounted() {
    this.$api.NewsService.GetDetailByCodeEvent.once(
      this.onGetDetailByCode.bind(this)
    );
    this.$api.NewsService.GetDetailByCode(this.$route.params.code);
  }
  onGetDetailByCode(response: WsResponseModel<NewsDetail>) {
    this.detail = response;
        if(response.Value)
          this.$meta.setTitle(response.Value.Name);
  }
}
